import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import newsService from "../../../services/news.service";
import Loadding from "../../common/loadding";
const NewsCarousel = () => {
  const [listNew, setListNew] = useState([]);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await newsService.getShow().then((res) => {
        setListNew(res.data);
        setStatus(false);
      });
    })();
  }, []);

  if (status) {
    return <Loadding />;
  }
  return (

    <div className="d-flex justify-content-center">
      <Carousel className="w-75">
        {/* //////////////////////////// */}

        {listNew.map((news: any) => {
          return (
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={`${BaseURL.BASE_URL}/upload/news/${news.image}`}
                alt="First slide"
              />
              <Carousel.Caption className="bg-white text-dark bg-opacity-75" >
                <h3>{news.title}</h3>
                <p>{news.discription}</p>

                {news.url && (
                  <a
                    className="btn btn-lg btn-primary btn-sm"
                    href={news.url}
                    target="_blank" rel="noreferrer"
                  >
                    รายละเอียดเพิ่มเติม
                  </a>
                )}
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}

        {/* //////////////////////////// */}
      </Carousel>
    </div>
  );
};

export default NewsCarousel;
